// SPDX-License-Identifier: AGPL-3.0-or-later

import * as CodeLinkUtils from '@app/features/messaging/utils/CodeLinkUtils';

const TEMPLATE_SHORT_URL_BASE = 'https://omnivybe.tr/t';

export const TEMPLATE_CONFIG: CodeLinkUtils.CodeLinkConfig = {
	path: 'template',
	get urlBases() {
		return ['https://omnivybe.com.tr/template', 'https://web.omnivybe.com.tr/template', TEMPLATE_SHORT_URL_BASE];
	},
};

export function findTemplates(content: string | null): Array<string> {
	return CodeLinkUtils.findCodes(content, TEMPLATE_CONFIG);
}

export function findTemplate(content: string | null): string | null {
	return CodeLinkUtils.findCode(content, TEMPLATE_CONFIG);
}

export function findSpoileredTemplates(content: string | null): Array<CodeLinkUtils.CodeLinkMatch> {
	return CodeLinkUtils.findSpoileredCodeMatches(content, TEMPLATE_CONFIG);
}
